<template>
  <div id="simple-calendar-app">

    <Loader cover v-if="processing"/>
    <div class="vx-card no-scroll-content">
      <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="calendarEventList"
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        :startingDayOfWeek="1"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-event="openEvent"
      >

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter">

            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDateFormat | month }}</span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center">
              <div></div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-end order-last">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ $t(`${view.i18n}`) }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ $t(`${view.i18n}`) }}</vs-button>
              </template>

            </div>
          </div>

        </div>

        <div slot="dayContent" class="mb-5">
          <div slot="item" class="mb-5" slot-scope="val">
            {{ val }}
          </div>
        </div>

      </calendar-view>
    </div>
    <vx-card
      v-if="activeViewEvent"
      class="view-event mt-base scroll-to-me"
      :title="$t('sections.liveschedule.detail-title')"
      :button-close-hidden="true">
      <div>
        <h6>
          {{ $t('live-class-schedule.topic') }}: {{ currentViewEvent.data.topicLocal }}
        </h6>
<!--        <p class="text-grey">
          {{ currentViewEvent.data.topicEng }}
        </p>-->
      </div>
      <div class="mb-6 mt-4">

        <h6 class="mb-4">
          {{ $t('live-class-schedule.subject-code') }}: {{ currentViewEvent.data.subjectCode }}
          {{$t('class-overview.section')}} {{ currentViewEvent.data.classSection.sectionNo }}
          {{$t('class-overview.span')}} {{ currentViewEvent.data.classSection.learnSpanNo }}
        </h6>

        <h6 class="mb-4">
          {{ $t('live-class-schedule.subject-name') }}: {{ currentViewEvent.data.subjectName }}
        </h6>

        <h6 class="mt-3">
          {{ $t('live-class-schedule.live-host') }}: {{ currentViewEvent.data.teacherFullName }}
        </h6>

      </div>
      <vs-divider></vs-divider>
      <div class="flex justify-start flex-wrap">
          <span>
            <p class="text-xl">
              {{ $t('general.live-start') }} {{ currentViewEvent.startDateFormat }} - {{currentViewEvent.endDateFormat }}
            </p>
            <p class="text-grey">
              {{ $t('live-class-schedule.live-from') }}: {{ currentViewEvent.data.liveFrom }}
            </p>
            <p class="text-grey">
              {{ $t('live-class-schedule.contract-info') }}: {{ currentViewEvent.data.contract || '-' }}
            </p>
            <p class="text-grey">
              {{ $t('live-class-schedule.remark') }}: {{ currentViewEvent.data.remark || '-'}}
            </p>
          </span>
      </div>
<!--      <pre>{{currentViewEvent.data}}</pre>-->
      <div class="mt-5 flex justify-end">
        <!--    EXTERNAL LIVE-->
        <vs-button v-if="currentViewEvent && currentViewEvent.data && currentViewEvent.data.externalLink"
                   color="success"
                   class="mr-2"
                   icon-pack="feather" icon="icon-link"
                   :disabled="!currentViewEvent.canViewLiveClass"
                   @click="goToExternalLink(currentViewEvent.data.externalLink)">
          {{ $t('live-class-schedule.go-to-external-link') }}
        </vs-button>

<!--        <vs-button v-if="currentViewEvent && currentViewEvent.data && currentViewEvent.data.externalPassword"
                   icon-pack="feather" icon="icon-copy"
                   :disabled="!currentViewEvent.canViewLiveClass"
                   v-clipboard:copy="currentViewEvent.data.externalPassword"
                   v-clipboard:success="onCopy">
          {{ $t('live-class-schedule.copy-password') }}
        </vs-button>-->

        <!--    NORMAL LIVE-->
<!--        <vs-button v-if="checkCurrentLive(currentViewEvent) && currentViewEvent && currentViewEvent.data && !currentViewEvent.data.externalLink"
                   @click="viewLiveClass(currentViewEvent.data)"
                   :disabled="!currentViewEvent.canViewLiveClass"
                   class="mx-2 bg-success">
          {{ $t('sections.liveschedule.view-liveclass') }}
        </vs-button>-->
      </div>

    </vx-card>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { CalendarView, /*CalendarViewHeader*/ } from "vue-simple-calendar"
import moduleCalendar from '@/store/modules/liveschedule/moduleCalendar.js'
require("vue-simple-calendar/static/css/default.css")

import { en, he } from "vuejs-datepicker/src/locale"
import {showLocalNotification, notificationType} from "@/utils/notification";
import store from "@/store";
import LiveClass from '@/store/modules/liveclass';
import {createNamespacedHelpers} from "vuex";

if (!store.state.LiveClass) store.state.registerModule(`LiveClass`, LiveClass);
const {
  mapActions: mapLiveClassActions,
} = createNamespacedHelpers(`LiveClass`);

export default {
  components: {
    CalendarView,
    // CalendarViewHeader,
    Loader: () => import('@/components/common-ui/loader-block/index.vue'),
  },
  data() {
    return {
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      startDate: '',
      endDate: '',
      labelLocal: 'none',
      currentViewEvent: {
        id: 0,
        title: '',
        startDate: '',
        endDate: '',
        labelLocal: 'none',
        data: {},
      },
      langHe: he,
      langEn: en,

      url: '',
      calendarView: 'month',

      activePromptAddEvent: false,
      activePromptEditEvent: false,
      activeViewEvent: false,

      calendarViewTypes: [
        {
          label: "Week",
          i18n: "general.time.week",
          val: "week"
        },
        {
          label: "Month",
          i18n: "general.time.month",
          val: "month"
        },
        {
          label: "Year",
          i18n: "general.time.year",
          val: "year"
        },
      ],
      calendarEvents: [],
      processing: true,
    }
  },
  computed: {
    calendarEventList() {
      return this.calendarEvents;
    },
    validForm() {
        return this.title !== ''
          && this.startDate !== ''
          && this.endDate !== ''
          && (Date.parse(this.endDate) - Date.parse(this.startDate)) >= 0
          && !this.errors.has('event-url');
    },
    disabledDatesTo() {
        return { to: new Date(this.startDate) }
    },
    disabledDatesFrom() {
        return { from: new Date(this.endDate) }
    },
    calendarLabels() {
        return this.$store.state.calendar.eventLabels
    },
    labelColor() {
        return (label) => {
            if (label === "business") return "success"
            else if (label === "work") return "warning"
            if (label === "personal") return "danger"
            if (label === "none") return "primary"
        }
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    currentLocale() {
      return this.$store.state["currentLocale"];
    },
    showDateFormat() {
      moment.locale(this.currentLocale);
      return moment(this.showDate);
    }
  },
  methods: {
    ...mapLiveClassActions({
      getLiveClassSchedulesCurrentUser: 'getLiveClassSchedulesCurrentUser',
    }),
    addEvent() {
        const obj = { title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
        obj.classes = "event-" + this.labelColor(this.labelLocal)
    },
    updateMonth(val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
    },
    clearFields() {
        this.title = this.endDate = this.url = "";
        this.id= 0;
        this.labelLocal = "none";
    },
    promptAddNewEvent(date) {
        this.disabledFrom = false;
        this.addNewEventDialog(date);
    },
    addNewEventDialog(date) {
        this.clearFields();
        this.startDate = date;
        this.endDate = date;
        this.activePromptAddEvent = true;
    },
    openAddNewEvent(date) {
        this.disabledFrom = true;
        this.addNewEventDialog(date);
    },
    openEvent(evt) {
      this.currentViewEvent = evt.originalEvent;
      this.activeViewEvent = true;
      setTimeout(() => {
        this.scrollToElement();
      }, 100)
    },
    closeEventViewer() {
      this.activeViewEvent = false;
    },
    openEditEvent(event) {
      const e = this.$store.getters['calendar/getEvent'](event.id)
      this.id = e.id
      this.title = e.title
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.url = e.url
      this.labelLocal = e.label
      this.activePromptEditEvent = true;
    },
    editEvent() {
      const obj = { id: this.id, title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
      obj.classes = "event-" + this.labelColor(this.labelLocal)
      this.$store.dispatch('calendar/editEvent', obj)
    },
    removeEvent() {
      this.$store.dispatch('calendar/removeEvent', this.id)
    },
    eventDragged(event, date) {
      this.$store.dispatch('calendar/eventDragged', {event: event, date: date})
    },
    mapLiveClassesToCalendar(liveClasses) {
      moment.locale(this.$i18n.locale);

      return liveClasses.map(item => {
        const startDate = moment(new Date(item.dateTimeFrom));
        const endDate = moment(new Date(item.dateTimeTo));
        return {
          id: item.id,
          startDate: startDate,
          endDate: endDate,
          startDateFormat: startDate.format("LLLL"),
          endDateFormat: endDate.format("HH:mm"),
          title: item.subjectCode,
          url: '',
          classes: '',
          data: item,
          canViewLiveClass: moment().isSameOrBefore(endDate)
        }
      })
    },
    checkCurrentLive(currentViewEvent) {
      if (currentViewEvent) {
        const currentPosixTime = new Date().getTime() / 1000;
        const eventStartDate = new Date(currentViewEvent.startDate).getTime() / 1000;
        const eventEndDate = new Date(currentViewEvent.endDate).getTime() / 1000;

        return currentPosixTime >= eventStartDate || currentPosixTime <= eventEndDate ? true : false;
      }
      return false;
    },
    viewLiveClass(liveClassData) {
      this.activeViewEvent = false;
      this.$store.dispatch("LiveClass/viewLiveClass", liveClassData, { root: true });
      this.$router.push('/e-learning/live-class');
    },
    goToExternalLink(link){
      window.open(link, '_blank');
    },
    onCopy(){
      showLocalNotification(this.$vs
        , this.$t('general.success'),
        this.$t('live-class-schedule.copy-success')
        , notificationType.SUCCESS);

    },
    cancel() {
      this.activeViewEvent = false;
    },
    scrollToElement() {
      const el = this.$el.getElementsByClassName('scroll-to-me')[0];

      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({behavior: 'smooth'});
      }
    },
    async loadData(){
      this.processing = true;
      const result = await this.getLiveClassSchedulesCurrentUser();
      if(result){
        this.calendarEvents = this.mapLiveClassesToCalendar(result);
        this.processing = false;
      }
    }
  },
  created() {
    this.$store.registerModule('calendar', moduleCalendar)
  },
  beforeDestroy() {
    this.$store.unregisterModule('calendar')
  },
  async beforeMount() {
    await this.loadData();
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
